import { useTranslation } from 'react-i18next';

/**
 * Translate helper honouring nav-config's optional fallback string.
 *
 * Lives in its own module so NavItem.tsx exports only components and
 * stays eligible for React Fast Refresh.
 */
export function useLabel() {
  const { t } = useTranslation();
  return (key: string, fallback?: string) =>
    fallback ? t(key, fallback) : t(key);
}
